import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { useFormContext, Controller } from 'react-hook-form'

import styles from './formItem.module.scss'

const FormItem = ({
  name,
  label,
  input,
  registerOptions,
  onChange,
  expand,
  style,
  position,
  className,
  ...others
}) => {
  const { register, errors, control, clearErrors } = useFormContext()
  const inputError = errors[input.props.name]
  const inputContent = onChange ? (
    <Controller
      name={name}
      render={({ onChange: rhfOnChange, ref }) =>
        React.cloneElement(input, {
          ...input.props,
          name,
          ref,
          error: inputError?.message,
          // Custom Props for Uncontrolled
          onChange: (...args) => {
            const data = onChange(...args)
            rhfOnChange(data)
          }
        })
      }
      control={control}
      rules={registerOptions}
      {...others}
      defaultValue={others?.defaultValue ? others.defaultValue : null}
    />
  ) : (
    React.cloneElement(input, {
      ...input.props,
      name,
      ref: register(registerOptions),
      error: inputError?.message,
      clearErrors,
      ...others
    })
  )
  return (
    <div
      className={classNames(styles.container, styles[position], className)}
      style={{ flexGrow: expand || 'inherit', ...style }}
    >
      <div> {label} </div>
      {inputContent}
    </div>
  )
}

FormItem.propTypes = {
  label: PropTypes.node,
  input: PropTypes.node.isRequired,
  registerOptions: PropTypes.object,
  useController: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  onChange: PropTypes.func
}

FormItem.defaultProps = {
  registerOptions: {},
  useController: false,
  style: {},
  className: ''
}

export default FormItem
